import React from 'react';
import Text from 'components/Core/Text';
import { CareersLocationsSection } from './styles';

const STCareerCoreSection = ({
  locationsLA,
  locationsATL,
  locationsYerevan,
  locationsColumbus,
  coreValues,
  ...otherProps
}) => (
  <CareersLocationsSection {...otherProps}>
    <div className="section-career-core--wrapper">
      <div className="section-career-core--container">
        <Text
          type={'h2'}
          alignDesktop={'center'}
          size={'28px'}
          className="careers--underlined-heading"
        >
          Locations
        </Text>
        <div className="section-career-core--content">
          <div
            className="section-career-core--item"
            style={{ backgroundImage: 'url("' + locationsLA + '")' }}
          >
            <div className="section-career-core--item-text-container">
              <Text type="h4" color="white" className="section-career-core--item-title">
                Los Angeles,
                <br /> California
              </Text>
              <Text
                type="p"
                color="white"
                size="normal"
                className="section-career-core--item-description"
              >
                Headquarters since 2010
                <br />
                800+ employees
              </Text>
            </div>
          </div>
          <div
            className="section-career-core--item"
            style={{ backgroundImage: 'url("' + locationsATL + '")' }}
          >
            <div className="section-career-core--item-text-container">
              <Text type="h4" color="white" className="section-career-core--item-title">
                Atlanta,
                <br /> Georgia
              </Text>
              <Text
                type="p"
                color="white"
                size="normal"
                className="section-career-core--item-description"
              >
                Opened in July 2017
                <br />
                145+ employees
              </Text>
            </div>
          </div>
          <div
            className="section-career-core--item"
            style={{ backgroundImage: 'url("' + locationsYerevan + '")' }}
          >
            <div className="section-career-core--item-text-container">
              <Text type="h4" color="white" className="section-career-core--item-title">
                Yerevan,
                <br /> Armenia
              </Text>
              <Text
                type="p"
                color="white"
                size="normal"
                className="section-career-core--item-description"
              >
                Opened in December 2018
                <br />
                125+ employees
              </Text>
            </div>
          </div>
          <div
            className="section-career-core--item"
            style={{ backgroundImage: 'url("' + locationsColumbus + '")' }}
          >
            <div className="section-career-core--item-text-container">
              <Text type="h4" color="white" className="section-career-core--item-title">
                Columbus,
                <br /> Ohio
              </Text>
              <Text
                type="p"
                color="white"
                size="normal"
                className="section-career-core--item-description"
              >
                Opened in February 2021
                <br />
                20+ employees
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CareersLocationsSection>
);

export default STCareerCoreSection;
